<template>
  <FormSubmitPopup :title="$t(isAddForecast ? 'addForecast' : 'forecastDetail')" v-model="value" :rightMethod="submit"
    @popupClose="$emit('close')" :rightButtonDisabled="isEmpty || (!isAddForecast && forecast.status !== 'ready')" hasAlert :rightButtonLoading="isLoading" large>
    <template v-slot:input>
      <v-flex md7 v-if="isAddForecast">
        <v-layout row justify-space-between>
          <v-flex md3 mr-3>
            <v-autocomplete :items="forecastWarehouses" v-model="forecast.curWarehouse" item-text="warehouseName"
              item-value="warehouseKey" return-object :label="$t('warehouse')" />
          </v-flex>
          <v-flex md3 mr-3>
            <v-autocomplete :items="(forecast.curWarehouse && forecast.curWarehouse.sites) || []"
              v-model="forecast.warehouseSite" :label="$t('warehouseSite')" item-text="siteName" item-value="key"
              :return-object="false" />
          </v-flex>
          <v-flex md3 mr-3>
            <v-autocomplete :items="[
                { text: $t('air'), value: 'air' },
                { text: $t('ocean'), value: 'ocean' },
                { text: $t('ground'), value: 'ground' },
              ]" v-model="forecast.shipType" item-text="text" item-value="value" :label="$t('shipType')" />
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex v-if="isAddForecast || forecast.status === 'ready'">
        <v-layout justify-space-between>
          <v-flex md11>
            <v-layout>
                <v-btn @click="addItem" v-if="canEdit()" color="primary">
                  <v-icon dark left>add</v-icon>
                  {{ $t('package') }}
                </v-btn>
                <v-btn color="primary" title="importFile" :loading="isUploading" :disabled="isUploadBtnDisabled">
                  <v-icon dark left>cloud_upload</v-icon>
                  {{ $t('upload') }}
                  <input type="file" class="hideInput" @change="uploadForecast" accept=".csv,.xls,.xlsx" />
                </v-btn>
                <v-btn color="primary" @click.stop="downloadTemplate">
                  <v-icon dark left class="mx-2">cloud_download</v-icon>
                  {{ $t('template') }}
                </v-btn>
            </v-layout>
          </v-flex>
          <v-flex xs4 md2 right id="text-field">
            <v-text-field append-icon="filter_list" :label="$t('search')" single-line hide-details v-model="filter"
              clearable></v-text-field>
          </v-flex>
        </v-layout>
      </v-flex>
          <v-data-table :headers="headers" :search="filter" :items="forecast.pkgItems || []" item-key="id" class="elevation-1">
            <template v-slot:headers="props">
              <tr>
                <th class="text-xs-left" v-for="header in props.headers" :key="header.text">
                  {{ header.text }}
                  <span style="cursor: pointer; color:blue;" v-if="header.hasAction && canEdit()"
                    @click="openBulkEditDialog(header.value)" icon small>
                    {{$t('batch')}}
                  </span>
                </th>
              </tr>
            </template>
            <template v-slot:items="props">
              <tr>
                <td class="text-xs-left">
                  <v-btn :disabled="isDisabledByPkg(props.item)" @click="removeItem(props.index)" icon small color="error">
                    <v-icon>delete</v-icon>
                  </v-btn>
                </td>
                <td class="text-xs-left">{{ getDisplayIndex(props) }}</td>
                <td style="max-width:100px">
                  
                  <v-text-field :disabled="true" v-if="isDisabledByPkg(props.item)" value="1" type="number" dense></v-text-field>
                  <v-text-field 
                    v-else
                    :disabled="isDisabledByPkg(props.item)"
                    @input="handlePkgQtyChange($event, props.item)"
                    v-model.number="props.item.pkgQty"
                    :rules="[fieldIsRequired('quantity'), fieldIsInteger('quantity'), fieldIsNoLessThanZero('quantity')]" 
                    type="number" 
                    dense>
                  </v-text-field>
                </td>
                <td style="max-width:100px">
                  <v-text-field v-if="isAddForecast && props.item.boxMark" :disabled="isDisabledByPkg(props.item)" v-model.trim="props.item.boxMark" dense></v-text-field>
                  <v-text-field @input="handleTrackingChange($event, props.item)" :disabled="isDisabledByPkg(props.item)" v-model.trim="props.item.tracking" dense></v-text-field>
                </td>
                <td class="text-xs-left">
                  <v-layout v-for="(item, i) in props.item.upcs" :key="props.index + '-' + i" row>
                    <v-flex>
                      <v-text-field disabled v-model.trim="item.upc" hide-details dense></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-btn :disabled="isDisabledByPkg(props.item)" small color="primary" @click="showSelectUpcPopup(props.item)">add sku</v-btn>
                  </v-layout>
                </td>
                <td class="text-xs-left">
                  <v-layout v-for="(item, i) in props.item.upcs" :key="props.index + '-' + i + '-name'" row>
                    <v-flex>
                      <v-text-field :disabled="isDisabledByPkg(props.item)" v-model.trim="item.productName" hide-details dense></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row mt-5>
                  </v-layout>
                </td>
                <td class="text-xs-left">
                  <v-layout v-for="(item, i) in props.item.upcs" :key="props.index + '-' + i + '-qty'" row>
                    <v-flex>
                      <v-text-field  :rules="[fieldIsRequired('quantity'), fieldIsInteger('quantity'), fieldIsNoLessThanZero('quantity')]" :disabled="isDisabledByPkg(props.item)" v-model.number="item.forecastQty" hide-details type="number" dense></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row mt-5>
                  </v-layout>
                </td>
                <td class="text-xs-left">
                  <v-layout class="mb-2" v-for="(item, i) in props.item.upcs" :key="props.index + '-' + i + '-qty'" row>
                    <v-btn :disabled="isDisabledByPkg(props.item)" @click="removeUpc(props.item, i)" icon small color="error">
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-layout>
                  <v-layout row mt-5>
                  </v-layout>
                </td>
              </tr>
            </template>
          </v-data-table>
          <v-layout row wrap class="mt-4" v-if="isAddForecast">
            <v-flex xs12 sm6 md4>
              <v-card class="pa-2" outlined tile>
                <div class="title">Total products: {{ totalProducts }}</div>
              </v-card>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-card class="pa-2" outlined tile>
                <div class="title">Total number of boxes: {{ totalBoxes }}</div>
              </v-card>
            </v-flex>
          </v-layout>
          <v-layout v-if="importErrors.length" class="mt-4">
            <v-flex xs12>
              <v-card class="error-card pa-3" outlined>
                <div class="subtitle-1 mb-2">{{$t('importErrors')}}</div>
                <v-list dense>
                  <v-list-tile v-for="(error, index) in importErrors" :key="index">
                    <v-list-tile-title>
                      <v-list-tile-title class="error--text">
                        {{$t('row')}} {{error.row}}: {{error.message}}
                      </v-list-tile-title>
                    </v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-card>
            </v-flex>
          </v-layout>
          <v-layout mt-3>
            <v-textarea :label="$t('note')" outline :disabled="!canEdit()"
              v-model="forecast.note" rows="3" counter="200" class="thinBox"></v-textarea>
          </v-layout>
      <FormSubmitPopup :title="`${$t('batch change')} ${$t(currentEditField)}`" v-if="bulkEditDialog" v-model="bulkEditDialog"
        :rightMethod="applyBulkEdit" @popupClose="closeBulkEditDialog" small>
        <template v-slot:input>
          <v-text-field :rules="[fieldIsRequired('quantity'), fieldIsInteger('quantity'), fieldIsNoLessThanZero('quantity')]" v-model.number="bulkEditValue" ></v-text-field>
        </template>
      </FormSubmitPopup>
      <FormSubmitPopup :title="$t('selectProduct')" v-if="isSelectUpcPopup" v-model="isSelectUpcPopup"
        :rightMethod="applyPackage" @popupClose="
      () => {
        isSelectUpcPopup = false
        reset()
      }
    " :rightButtonDisabled="!selectedUPC.length" hasAlert :rightButtonLoading="isLoading" medium>
        <template v-slot:input>
          <v-layout text-right>
            <v-text-field append-icon="filter_list" :label="$t('search')" single-line hide-details v-model="search"
              clearable></v-text-field>
          </v-layout>
          <v-data-table :headers="upcHeaders" :items="productsWithDimensions" :items-per-page="25" :search="search"
            item-key="upc" v-model="selectedUPC" select-all="blue" class="elevation-1">
            <template v-slot:items="props">
              <td class="checkbox-align-center" @click="props.selected = !props.selected">
                <v-layout>
                  <v-checkbox @click.stop="
                () => {
                  props.selected = !props.selected
                }
              " :value="props.selected" primary hide-details></v-checkbox>
                </v-layout>
              </td>
              <td class="text-xs-left">{{ props.item.upc }}</td>
              <td class="text-xs-left">{{ props.item.name }}</td>
              <td class="text-xs-left">{{ `${props.item.length || 0}/${props.item.width || 0}/${props.item.height || 0}
                ${getUnit(props.item.unit)}` }}</td>
            </template>
          </v-data-table>
        </template>
      </FormSubmitPopup>
    </template>
  </FormSubmitPopup>
</template>

<script>
import FormSubmitPopup from './FormSubmitPopup.vue'
import { checkRules, timeTools, readXlsxSheetData, warehouseTools, stringTools, cloneDeep } from '@/utils/tools'
import BarcodeFinder from '../utils/barcode'
import { measurementUnits, weightUnits } from '@/utils/const'

export default {
  components: {
    FormSubmitPopup
  },
  mixins: [checkRules, timeTools, warehouseTools, stringTools],
  data () {
    return {
      isUploading: false,
      uploadedFiles: [],
      isLoading: false,
      isAddPackage: false,
      pkg: {},
      filter: '',
      upcFilter: '',
      isEditItem: false,
      isCheckTracking: false,
      isCheckUpc: false,
      oldTrackings: [],
      originPkgsMap: {},
      measurementUnits: measurementUnits,
      referenceNo: '',
      notes: '',
      items: [],
      bulkEditDialog: false,
      currentEditField: '',
      bulkEditValue: '',
      isSelectUpcPopup: false,
      search: '',
      selectedUPC: [],
      editInPkg: {},
      displayQty: 1,
      importErrors: []
    }
  },
  mounted () {
    if (!this.isAddForecast && this.forecast.pkgItems?.length) {
      this.oldTrackings = this.forecast.pkgItems.map(pkg => pkg.tracking.toUpperCase())
      this.originPkgsMap = cloneDeep(this.forecast.pkgItems).reduce((acc, pkg) => {
        acc[pkg.tracking.toUpperCase()] = pkg
        return acc
      }, {})
    }
    this.pkg = this.initPkg()
  },
  computed: {
    upcHeaders () {
      return [
        { text: this.$t('sku'), value: 'upc', sortable: false },
        { text: this.$t('name'), value: 'name', sortable: false },
        { text: this.$t('size'), value: 'keywords', sortable: false }
      ]
    },
    filteredProducts () {
      return this.productsWithDimensions.filter(product => {
        return product.name.toLowerCase().includes(this.search.toLowerCase())
      })
    },
    totalProducts () {
      return this.forecast.pkgItems.reduce((sum, item) => {
        item.upcs.forEach(upc => {
          sum += parseInt(upc.forecastQty) * item.pkgQty
        })
        return sum
      }, 0)
    },
    totalBoxes () {
      return this.forecast.pkgItems.reduce((sum, item) => sum + parseInt(item.pkgQty), 0)
    },
    sizeSuffix () {
      return measurementUnits[this.pkg.unit] || 'INCH'
    },
    weightSuffix () {
      return weightUnits[this.pkg.unit] || 'LB'
    },
    isDuplicateUpc () {
      if (Array.isArray(this.pkg.upcs)) {
        return this.pkg.upcs.some((item, index) => {
          if (index === 0) return false
          return this.pkg.upcs.slice(0, index).some(item2 => item2.upc === item.upc)
        })
      }
      return false
    },
    historyTrackings () {
      return this.$store.getters.tenantForecastTrackings || []
    },
    products () {
      return this.$store.getters.productsWithUpcChangeableFlag || []
    },
    productsWithDimensions () {
      return this.products.filter(product => product.length && product.width && product.height)
    },
    headers () {
      return [
        { text: this.$t('delete'), sortable: false },
        { text: this.$t('index'), sortable: false },
        { text: this.$t('pkgQty'), value: 'pkgQty', sortable: false },
        { text: this.$t('tracking'), value: 'tracking', sortable: false },
        { text: this.$t('sku'), value: 'upc', sortable: false },
        { text: this.$t('productName'), value: 'productName', sortable: false },
        { text: this.$t('quantityPerBox'), value: 'forecastQty', hasAction: true, sortable: false },
        { text: this.$t('actions'), value: 'actions', sortable: false }
      ]
    },
    rowPerPage () {
      return [30, 50, {text: this.$t('all'), value: -1}]  
    },
    isAddPkgEmpty () {
      if (this.pkg.tracking === '' || this.pkg.upcs.some(item => item.upc === '')) return true
      return false
    },
    isUploadBtnDisabled () {
      return this.isUploading
    },
    isEmpty () {
      return JSON.stringify(this.forecast.curWarehouse) === '{}' || !(this.forecast.warehouseSite && this.forecast.shipType && this.forecast.pkgItems?.length)
    },
    tenantInfo () {
      return this.$store.getters.tenant || {}
    },
    isOpenPackageManageOrg () {
      return !!this.tenantInfo?.featureInboundForecastPkg?.length
    },
    forecastWarehouses () {
      const {featureInboundForecast = [], featureInboundForecastPkg = [], featureInboundForecastDropshipping = []} = this.tenantInfo
      const warehouseKeys = [...new Set([...featureInboundForecast, ...featureInboundForecastPkg, ...featureInboundForecastDropshipping])]
      return this.warehouses.filter(warehouse => warehouseKeys.includes(warehouse.warehouseKey)) || []
    },
    isDClass () {
      return !!this.tenantInfo.featureInboundForecastDropshipping?.length
    },
    warehouses () { 
      return this.$store.getters.warehouses
    }
  },
  methods: {
    handlePkgQtyChange (value, item) {
      const qty = parseInt(value)
      if (qty > 1) {
        if (item.tracking) {
          item.tracking = ''
        }
      }
    },
    handleTrackingChange (value, item) {
      if (value && item.pkgQty > 1) {
        item.pkgQty = 1
      }
    },
    canEdit () {
      return this.isAddForecast || this.forecast.status === 'ready'
    },
    isDisabledByPkg (item) {
      return (!this.isAddForecast && this.forecast.status !== 'ready') || 
        item.upcs.reduce((qty, item) => qty + item.inboundQty, 0) > 0
    },
    getUnit (unit) {
      return measurementUnits[unit]
    },
    removeUpc (item, index) {
      item.upcs.splice(index, 1)
    },
    showSelectUpcPopup (row) {
      this.selectedUPC = []
      this.editInPkg = row
      this.search = ''
      this.isSelectUpcPopup = true
    },
    closeSelectUpcPopup () {
      this.editInPkg = this.initItem()
      this.isSelectUpcPopup = false
    },
    addSku (item) {
      item.upcs.push(this.initSku())
    },
    getDisplayIndex (props) {
      const { index, item } = props
      const { pkgQty } = item

      const startTotal = this.forecast.pkgItems.slice(0, index).reduce((sum, item) => sum + Number(item.pkgQty || 1), 0)

      const startBox = startTotal + 1
      const endBox = startBox + Number(pkgQty) - 1

      return pkgQty > 1 ? `${startBox} - ${endBox}` : startBox.toString()
    },
    initSku () {
      return { upc: '', productName: '', forecastQty: 1 }
    },
    initItem () {
      const pkg = {
        pkgQty: 1,
        upcs: [],
        tracking: '',
        isCheckPackage: false
      }
      return pkg
    },
    addItem () {
      this.forecast.pkgItems.push(this.initItem())
    },
    removeItem (index) {
      this.forecast.pkgItems.splice(index, 1)
    },
    updatePkgQty (item) {
      item.pkgQty = Math.max(1, Math.floor(Number(item.pkgQty)))
    },
    openBulkEditDialog (field) {
      this.currentEditField = field
      this.bulkEditValue = ''
      this.bulkEditDialog = true
    },
    closeBulkEditDialog () {
      this.bulkEditDialog = false
    },
    applyBulkEdit () {
      this.forecast.pkgItems.forEach(item => {
        if (item.upcs) {
          item.upcs.forEach(upc => {
            upc[this.currentEditField] = this.bulkEditValue
          })
        }
      })
      this.closeBulkEditDialog()
    },
    reset () {
      this.pkg = this.initPkg()
    },
    initPkg () {
      const pkg = {
        pkgQty: 1,
        upcs: [{upc: '', productName: '', forecastQty: 1}],
        isCheckPackage: false
      }
      return pkg
    },
    isPackageManagementOrg (warehouseKey) {
      return this.tenantInfo.featureInboundForecastPkg?.includes(warehouseKey)
    },
    isDClassForWarehouse (warehouseKey) {
      return this.tenantInfo.featureInboundForecastDropshipping?.includes(warehouseKey)
    },
    handlerHistoryTrackings (pkgItems = []) {
      const historySet = new Set(this.historyTrackings)
      let dupTrackings = new Set()
      let newAddTrackings = new Set()
      const currentTrackings = new Set()
      pkgItems.forEach(pkg => {
        if (!pkg.tracking) return
        pkg.tracking = pkg.tracking.toUpperCase()
        if (!historySet.has(pkg.tracking) && !currentTrackings.has(pkg.tracking)) {
          newAddTrackings.add(pkg.tracking)
        } else {
          dupTrackings.add(pkg.tracking)
        }
        currentTrackings.add(pkg.tracking)
      })

      return {
        dupTrackings,
        newAddTrackings
      }
    },
    getProductName (upc) {
      return this.products.find(product => product.upc === upc || product.upc?.includes(upc))?.name
    },
    isUpcValid (upc) {
      return BarcodeFinder.isUpcValid(upc)
    },
    isTrackingNumberValid (tracking) {
      let _trk = this.trimNonwordChar(tracking) 
      return !!this.guessCarrier(_trk).length
    },
    checkTracking () {
      this.isCheckTracking = true
    },
    checkUpc () {
      this.isCheckUpc = true
    },
    editPkg (pkg) {
      this.isAddPackage = true
      this.isEditItem = true
      pkg = JSON.parse(JSON.stringify(pkg))
      this.pkg = pkg || this.initPkg()
    },
    deletePkg (pkg) {
      if (!confirm(this.$t('confirmDeletePackage'))) return
      this.forecast.pkgItems = this.forecast.pkgItems.filter(item => item.tracking.toUpperCase() !== pkg.tracking.toUpperCase()) || []
    },
    applyPackage () {
      const upcs = this.editInPkg.upcs
      const uniqueUPCs = this.selectedUPC.filter(item => !upcs.some(upc => upc.upc === item.upc))
      this.editInPkg.upcs = upcs.concat(uniqueUPCs.map(item => {
        return {
          upc: item.upc,
          productName: item.name,
          forecastQty: 1
        }
      }))
    },
    savePackage () {
      if (JSON.stringify(this.pkg) !== '{}') {
        if (!Array.isArray(this.forecast.pkgItems)) this.forecast.pkgItems = []
        this.pkg = {...this.pkg,
          tracking: this.trimNonwordChar(this.pkg.tracking),
          upcs: this.pkg.upcs.map(item => {
            item.upc = this.trimNonwordChar(item.upc)
            return item
          })}
        this.forecast.isPackageManagement && (this.pkg.packageStatus = 'initial')
        let index = this.forecast.pkgItems.findIndex(item => this.trimNonwordChar(item.tracking.toUpperCase()) === this.pkg.tracking.toUpperCase())
        if (index === -1) {
          this.forecast.pkgItems.unshift(this.pkg)
        } else {
          if (!this.isEditItem && !confirm(this.$t('dupTrackingNumber'))) throw Error(this.$t('dupTrackingNumber'))
          this.$set(this.forecast.pkgItems, index, this.pkg)
        }
        this.reset()
      }
    },
    addUPC () {
      if (!this.pkg.upcs) this.pkg.upcs = []
      this.pkg.upcs.unshift({upc: '', productName: '', forecastQty: 1})
    },
    async submit () {
      this.isAddForecast ? await this.addForecast() : await this.updateForecast()
    },
    generateBoxMark (orgId, index) {
      const time = new Date()
      const curDayStr = time.toISOString().slice(0, 10).replace(/-/g, '')
      const formattedMillis = time.getTime().toString().slice(-10)
      return `${orgId}-${curDayStr}${formattedMillis}-${index}`
    },
    async processForecast (isNewForecast) {
      let {
        pkgItems = [],
        curWarehouse: { warehouseKey = '' },
        warehouseSite = '',
        shipType = '',
        note = ''
      } = this.forecast
      const queueLength = 5000
      let packages = {}
      const orgId = this.getOrgId(warehouseKey)
      const boxMarks = []
      let keywords = new Set([
        this.$store.getters.activeOrganization,
        warehouseKey,
        warehouseSite
      ])
      
      let { dupTrackings = new Set(), newAddTrackings = new Set() } = this.handlerHistoryTrackings(pkgItems)
      if (dupTrackings.size) {
        alert(this.$t('forecastTrackingDupWarning', {trackings: [...dupTrackings].join(', ')}))
        throw Error(this.$t('forecastTrackingDupWarning', {trackings: [...dupTrackings].join(', ')}))
      } 
      let historyTrackings = [...this.historyTrackings, ...newAddTrackings]
      historyTrackings.splice(0, historyTrackings.length - queueLength)
      pkgItems.forEach((pkg, index) => {
        let { tracking = '', upcs = [], isCheckPackage = false, pkgQty = 0 } = pkg
        for (let i = 0; i < pkgQty; i++) {
          upcs.forEach(item => {
            item.upc && keywords.add(item.upc.toUpperCase())
          })
          tracking = this.trimNonwordChar(tracking.toUpperCase())
          let boxMark = this.generateBoxMark(orgId, boxMarks.length + 1)
          boxMarks.push(boxMark)
          keywords.add(boxMark)
          packages[boxMark] = {
            upcs: upcs
          }
          if (this.isPackageManagementOrg(warehouseKey)) {
            packages[boxMark].packageStatus = 'initial'
            packages[boxMark].isCheckPackage = isCheckPackage
          }
          if (tracking) {
            let cornetTracking = this.guessCarrier(tracking)[0]?.tracking?.[0]
            cornetTracking && keywords.add(cornetTracking)
            packages[boxMark].tracking = tracking
            keywords.add(tracking)
          }
          if (this.isDClassForWarehouse(warehouseKey)) {
            packages[boxMark].boxMark = boxMark
          }
          keywords.add(boxMark)
        }
      })
      keywords = [...keywords]
      let payload = {
        isNewForecast,
        forecast: {
          organizationKey: this.$store.getters.activeOrganization,
          packages,
          warehouseKey,
          warehouseSite,
          shipType,
          note,
          keywords,
          status: 'ready'
        },
        historyTrackings
      }
      if (this.isPackageManagementOrg(warehouseKey)) {
        payload.forecast.isPackageManagement = true
        payload.forecast.shipmentStatus = 'initial'
      } else if (this.isDClassForWarehouse(warehouseKey)) {
        payload.forecast.boxMarks = boxMarks
        payload.forecast.isDClass = true
      }

      return payload
    },
    async addForecast () {
      const payload = await this.processForecast(true)
      const res = await this.$store.dispatch('updateForecast', payload).catch(e => {
        this.$store.dispatch('showToast', {
          level: 'error',
          info: e.message
        })
        throw e
      })
      this.$emit('addForecast', {...res, createTime: new Date(), lastModifiedTime: new Date(), isMockItem: true})
    },
    async updateForecast () {
      try {
        const { pkgItems = [], note = '', _key, lastModifiedTime, warehouseKey, warehouseSite, organizationKey, status } = this.forecast
        const keywords = new Set([
          organizationKey,
          warehouseKey,
          warehouseSite
        ])
        let newAddItems = []
        const queueLength = 5000
        let curOldTrackings = []
        pkgItems.forEach(pkg => {
          if (!pkg.tracking) return
          if (!this.oldTrackings.includes(pkg.tracking.toUpperCase())) {
            newAddItems.push(pkg)
          } else {
            curOldTrackings.push(pkg.tracking.toUpperCase())
          }
        })
        let deletedTrackings = this.oldTrackings.filter(trk => !curOldTrackings.includes(trk))

        let { dupTrackings = new Set(), newAddTrackings = new Set() } = this.handlerHistoryTrackings(newAddItems)

        if (dupTrackings.size) {
          alert(this.$t('forecastTrackingDupWarning', {trackings: [...dupTrackings].join(', ')}))
          throw Error(this.$t('forecastTrackingDupWarning', {trackings: [...dupTrackings].join(', ')}))
        }

        let historyTrackings = [...this.historyTrackings, ...newAddTrackings].filter(trk => !deletedTrackings.includes(trk))
        historyTrackings.splice(0, historyTrackings.length - queueLength)

        const packages = {}
        const boxMarks = []
        const orgId = this.getOrgId(warehouseKey)
        pkgItems.forEach((pkg) => {
          let { tracking = '', upcs = [], pkgQty = 0 } = pkg
          for (let i = 0; i < pkgQty; i++) {
            upcs.forEach(item => {
              item.upc && keywords.add(item.upc.toUpperCase())
            })

            tracking = this.trimNonwordChar(tracking.toUpperCase())
            const boxMark = this.generateBoxMark(orgId, boxMarks.length + 1)
            boxMarks.push(boxMark)
            keywords.add(boxMark)

            packages[boxMark] = {
              upcs: upcs
            }

            if (tracking) {
              const cornetTracking = this.guessCarrier(tracking)[0]?.tracking?.[0]
              cornetTracking && keywords.add(cornetTracking)
              packages[boxMark].tracking = tracking
              keywords.add(tracking)
            }

            if (this.isDClassForWarehouse(warehouseKey)) {
              packages[boxMark].boxMark = boxMark
            }
          }
        })
        let isPartial = (status && status !== 'ready') && Object.keys(packages).some(key => {
          return packages[key].upcs.some(
            pkg => !pkg.inboundQty || pkg.inboundQty !== pkg.forecastQty
          )
        })
        const updatePayload = {
          forecast: {
            key: _key,
            packages,
            keywords: [...keywords],
            note,
            status: status === 'ready' ? status : (isPartial ? 'partial' : 'done')
          },
          lastModifiedTime,
          historyTrackings
        }
        if (this.isDClassForWarehouse(warehouseKey)) {
          updatePayload.forecast.boxMarks = boxMarks
        }
        const res = await this.$store.dispatch('updateForecast', updatePayload)
        
        this.$emit('updateForecast', {
          ...res,
          lastModifiedTime: new Date()
        })
      } catch (error) {
        this.$store.dispatch('showToast', {
          level: 'error',
          info: error.message
        })
        throw error
      }
    },
    getOrgId (warehouseKey) {
      return this.warehouses.find(warehouse => warehouse.warehouseKey === warehouseKey)?.orgId
    },
    downloadTemplate () {
      this.$store.dispatch('downloadFile', {
        fullPath: 'templates/forecast-D-template.xlsx',
        name: 'forecast-template.xlsx'
      })
    },
    async uploadForecast (e) {
      this.isUploading = true
      try {
        const files = e.target.files
        let rawData = await readXlsxSheetData(files)
        if (rawData.length) return this.processSheetData(rawData)
        else this.isUploading = false
      } catch (error) {
        throw error
      } finally {
        this.isUploading = false
      }
    },
    async processSheetData (rawData = []) {
      this.importErrors = []
      const map = new Map()
      const headers = ['Box Number', 'Tracking', 'UPC', 'Quantity']
      
      for (let i = 0; i < rawData.length; i++) {
        const line = rawData[i]
        const rowNum = i + 2
        if (!line[headers[0]]) {
          this.importErrors.push({
            row: rowNum,
            message: this.$t('InvalidBoxNumber')
          })
          continue
        }

        if (!line[headers[2]]) {
          this.importErrors.push({
            row: rowNum,
            message: this.$t('InvalidUPC')
          })
          continue
        }

        if (!line[headers[3]]) {
          this.importErrors.push({
            row: rowNum,
            message: this.$t('invalidQuantity')
          })
          continue
        }

        const boxNumber = line[headers[0]].toString().trim()
        const tracking = line[headers[1]] ? this.trimNonwordChar(line[headers[1]].toString().toUpperCase()) : ''
        const upc = this.trimNonwordChar(line[headers[2]].toString())
        const forecastQty = parseInt(line[headers[3]])
        const pkgQty = 1

        const product = this.productsWithDimensions.find(p => p.upc === upc)
        if (!product) {
          this.importErrors.push({
            row: rowNum, 
            message: this.$t('invalidUPC', {upc})
          })
          continue
        }

        if (isNaN(forecastQty) || forecastQty <= 0) {
          this.importErrors.push({
            row: rowNum,
            message: this.$t('invalidQuantity')
          })
          continue
        }

        if (!map.has(boxNumber)) {
          map.set(boxNumber, {
            tracking,
            pkgQty: pkgQty,
            upcs: [{
              upc,
              productName: product.name,
              forecastQty
            }]
          })
        } else {
          const pkg = map.get(boxNumber)
          const existingUpc = pkg.upcs.find(u => u.upc === upc)
          if (existingUpc) {
            existingUpc.forecastQty += forecastQty
          } else {
            pkg.upcs.push({
              upc,
              productName: product.name,
              forecastQty
            })
          }
        }
      }

      this.forecast.pkgItems = [...map.values(), ...this.forecast.pkgItems || []]
      if (this.importErrors.length > 0) {
        this.$store.dispatch('showToast', {
          level: 'error',
          info: this.$t('importWithErrors', {count: this.importErrors.length})
        })
      } else {
        this.$store.dispatch('showToast', {
          level: 'success',
          info: this.$t('success')
        })
      }
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    isAddForecast: {
      type: Boolean,
      default: false
    },
    forecast: {
      type: Object,
      default: () => ({
        warehouseSite: '',
        shipType: '',
        curWarehouse: {},
        note: '',
        pkgItems: []
      })
    }
  }
}
</script>

<style scoped>
  .hideInput {
    position: absolute;
    top: 0;
    right: 0;
    max-width: 100%;
    min-width: 100%;
    min-height: 100%;
    text-align: right;
    filter: alpha(opacity=0);
    opacity: 0;
    outline: none;
    cursor: inherit;
    display: block;
  }
  #text-field .v-text-field{
    padding-top: 5px;
  }
  .error-card {
    border: 1px solid #ff5252 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/DropshippingForecastPopup.vue